import { useState, useRef, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { addMultipleSuppliers } from "../../../services/suppliers";

const AddMultipleSuppliersLogic = ({
  closeWidget,
  handleFetchSuppliers = () => {},
}) => {
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const inputRef = useRef();

  const handleSupplierUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return triggerToast("Please select a file", "warning");

    if (event.target.files[0].size > 10000000) {
      return triggerToast("File size should be less than 10mb", "warning");
    }

    setIsUploadingFile(true);
    setRequestLoaderProgress(40);

    const formData = new FormData();
    formData.append("file", file);

    addMultipleSuppliers(formData)
      .then(() => {
        setIsUploadingFile(false);
        setRequestLoaderProgress(100);
        inputRef.current.value = null;
        triggerToast("File uploaded successfully", "success");
        handleFetchSuppliers();
        closeWidget();
      })
      .catch(() => {
        setIsUploadingFile(false);
        setRequestLoaderProgress(100);
        inputRef.current.value = null;
      });
  };

  return {
    isUploadingFile,
    inputRef,
    handleSupplierUpload,
  };
};

export default AddMultipleSuppliersLogic;
